export default "/ManualBackground.png";